import React from 'react';
import { Helmet } from 'react-helmet';
import { Box } from '@mui/material';
import { useAccount } from '../../contexts/Account';

function AnimatedRedirect() {
  const { currentPlan } = useAccount();

  React.useEffect(() => {
    const interval = setInterval(() => {
      window.location.replace(currentPlan.onboardingRedirectUrl);
    }, 4800);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>Loading Profile - AdvisoryCloud</title>
      </Helmet>

      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <iframe
          src="https://cdn.advisorycloud.com/static-content/loading-v2.html"
          title="Loading Profile"
          frameBorder="0"
          style={{
            width: '100%',
            height: '400px',
            overflowX: 'visible',
          }}
        />
      </Box>
    </>
  );
}

export default AnimatedRedirect;
